import * as React from 'react';
import { IconBase } from 'react-icons';
function DeprecatedPlusIcon(props, svgRef) {
    return (
        <IconBase fill="none" viewBox="0 0 17 16" ref={svgRef} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.154 7V1c0-.552.454-1 1.014-1s1.014.448 1.014 1v6h6.085c.56 0 1.014.448 1.014 1s-.454 1-1.014 1H9.182v6c0 .552-.454 1-1.014 1s-1.014-.448-1.014-1V9H1.07C.51 9 .056 8.552.056 8S.51 7 1.07 7h6.084z"
                fill="currentColor"
            />
        </IconBase>
    );
}
const ForwardRef = React.forwardRef(DeprecatedPlusIcon);
export default ForwardRef;
